<template>
  <v-row class="mr-4 ml-4">
    <v-text-field
      :label="$t(title) + '*'"
      v-model="textData"
      :error-messages="errorMessage"
      @change="onChange"
      :disabled="disabled"
      v-on:blur="
        () => {
          this.wasBlurred = true;
        }
      "
      required
    />
  </v-row>
</template>

<script>
export default {
  model: {
    prop: 'value',
    event: 'valueEv',
  },
  props: {
    value: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    needCheck: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: '',
    },
    busyValues: [],
  },
  data() {
    return {
      textData: '',
      wasBlurred: false,
    };
  },
  watch: {
    value() {
      this.textData = this.value;
    },
  },
  computed: {
    errorMessage() {
      if (!this.needCheck && !this.wasBlurred) return '';

      return this.checkField();
    },
  },

  methods: {
    onChange() {
      this.$emit('valueEv', this.textData);
    },
    checkField() {
      if (this.value == null || this.value.length == 0)
        return this.$t('validations.notEmpty');

      if (this.busyValues != null && this.busyValues.length != 0)
        if (this.busyValues.indexOf(this.value, 0) != -1)
          return this.$t('errorsMessages.BusyName');

      return '';
    },
  },
  mounted() {
    this.textData = this.value;
  },
};
</script>
